// extracted by mini-css-extract-plugin
module.exports = {"container":"InterviewTeam_container__kbYlo","header":"InterviewTeam_header__KkE3X"};